<template>
<v-container>
  <toast v-model="toastText"></toast>
  <v-toolbar flat color="transparent" v-if="!loading">
    <v-form class="mx-4">
      <v-text-field :disabled="!userId || allScene.length==0" v-model="searchWord" prepend-icon="search" :placeholder="$t('scene.search')" hide-details single-line clearable></v-text-field>
    </v-form>
  </v-toolbar>
  <v-layout row v-if="loading">
    <progress-dialog>{{ $t('loading') }}</progress-dialog>
  </v-layout>
  <v-layout row justify-center v-else-if="allScene.length===0">
    <span class="title grey--text mt-5 text-xs-center">{{ $t('scene.no_scene_available') }}</span>
  </v-layout>
  <v-layout row justify-center v-else-if="filteredScene.length===0">
    <span class="title grey--text mt-5 text-xs-center">{{ $t('scene.no_scene_matched') }}</span>
  </v-layout>
  <v-layout row wrap v-else class="mt-2">
    <v-flex xs12 sm6 md4 lg3 xl2 v-for="item in filteredScene" :key="item.key" class="px-2 py-2">
      <v-card>
        <v-list two-line class="py-0">
          <v-list-tile avatar @click="enableScene(item)">
            <v-list-tile-avatar>
              <v-icon :color="item.invisible==1?'grey':'primary'" size="36">theaters</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.mac }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  UserAuth
} from 'luffanet-web-components'

export default {
  name: 'Scene',
  mixins: [UserAuth],
  data: () => ({
    toastText: null,
    scene: [],
    searchWord: null,
    loading: true
  }),
  computed: {
    allScene() {
      let list = [];
      this.scene.forEach(gateway => {
        let key = gateway['.key'];
        let values = gateway['.value'];
        values.forEach(v => {
          list.push({
            key: key + v.title,
            mac: key,
            ...v
          });
        });
      });
      return list;
    },
    filteredScene() {
      let data = this.allScene;
      if(data && this.searchWord && this.searchWord.length > 0)
        data = data.filter(item => item.title.toLowerCase().indexOf(this.searchWord.toLowerCase()) != -1);
      return data;
    }
  },
  methods: {
    load() {
      this.$bindAsArray('scene', this.$db.ref('userScene').child(this.userId), null, function() {
        this.loading = false;
      });
    },
    async enableScene(item) {
      let ref = this.$db.ref('command').push();
      try {
        await ref.set({
          mac: item.mac,
          cmd: 'doscene',
          val: item.title
        });
      } catch (err) {
        this.toastText = this.$t('scene.permission_denied');
        return;
      }
      this.toastText = this.$t('scene.enable_scene', {
        name: item.title,
        mac: item.mac
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/scene.vue